import { getHrpBulkActionDefinitions } from "../../utils/billingRateUtils";

const HrpReconciliationBulkActions = ({ rows, onBulkAction, className = "", excludeBulkActions = [] }) => {
    const excluded = new Set(excludeBulkActions);
    const actions = getHrpBulkActionDefinitions(rows);
    const visible = actions.filter(({ key, count }) => {
        if (excluded.has(key)) return false;
        return key === "skip" || count > 0;
    });
    if (visible.length === 0) return null;

    return (
        <div className={["billing-rate-builder__hrp-bulk-actions", className].filter(Boolean).join(" ")}>
            {visible.map(({ key, label, bulkAction, count }) => (
                <button
                    key={key}
                    type="button"
                    className="btn billing-rate-builder__table-action-btn billing-rate-builder__hrp-bulk-btn"
                    disabled={count === 0}
                    onClick={() => onBulkAction?.(bulkAction)}
                >
                    {label}
                </button>
            ))}
        </div>
    );
};

export default HrpReconciliationBulkActions;
